import React from 'react'
import {
  Badge,
  Collapse,
  Grid,
  Menu,
  Pagination,
  Space,
  Table,
} from '@mantine/core'

import { PageContentContainer } from '../components/PageContentContainer/PageContentContainer'
import { TextInput } from '../components/TextInput/TextInput'
import { Button } from '../components/Button/Button'
import { Anchor } from '../components/Anchor/Anchor'
import { Select } from '../components/Select/Select'
import { Checkbox } from '../components/Checkbox/Checkbox'
import { Text } from '../components/Text/Text'

export function AdminListQuotesPageHeader = (cols = [
  null,
  'Booking Ref',
  'Name',
  'Quote Date',
  'Agent',
  'Link',
  'Description',
  'Offer expires',
  'Status',
  null,
]):JSX.Element => {
  return (
    <tr>
      {cols.map((v:string|null)=>{
        if(!v) return (<th></th>)
          return (<th>
            <Anchor styleType="table-header">{v}</Anchor>
          </th>)
      })}
    </tr>
  )
}

export function AdminListQuotesPageNestedHeader = (cols = {
  before: [null],
  'Group 1':['Booking Ref','Name','Quote Date'],
  'Group 2':['Agent','Link','Description'],
  'Group 3':['Offer expires','Status'],
  after: [null],
}):JSX.Element => {
  const {before=[],after=[],...groups} = cols
  return (<>
    <tr>
      {before.map((v:string|null)=> v ? (<th> <Anchor styleType="table-header">{v}</Anchor> </th>) : (<th></th>))}
      {Object.entries(groups).map(([k,v]:[string,Array<string|null>],i:number)=>
        (v ? (<th key={i} colSpan={v?.length??1}><Anchor styleType="table-header">{k}</Anchor></th>) : (<th></th>))
      )}
      {after.map((v:string|null)=> v ? (<th> <Anchor styleType="table-header">{v}</Anchor> </th>) : (<th></th>))}
    </tr>
    <tr>
      {before.map((v:string|null)=>(<th></th>))}
      {Object.entries(groups).flatMap(([k,v]:[string,Array<string|null>],i:number)=>
        v.map((v,j)=>(v ? (<th key={i+'.'+j}><Anchor styleType="table-header">{v}</Anchor></th>) : (<th></th>)))
      )}
      {after.map((v:string|null)=>(<th></th>))}
    </tr>
  </>)
}
export function AdminListQuotesPage({
  heading = <h2>Trips</h2>,
  topControlsArea = AdminListQuotesPage.TopControlsArea({}),
  tableHeadingRow = AdminListQuotesPageHeader(),
  tableRows = [
    AdminListQuotesPage.TableRow({}),
    AdminListQuotesPage.TableRow({}),
    AdminListQuotesPage.TableRow({}),
  ],
  bottomArea = AdminListQuotesPage.BottomArea({}),
  theadStyles = {},
  extras = {},
  containerPadding = 10,
}: {
  heading?: React.ReactNode
  topControlsArea?: React.ReactNode
  tableHeadingRow?: React.ReactNode
  tableRows?: React.ReactNode
  bottomArea?: React.ReactNode
  theadStyles?: any
  extras?: Record<string,any>
  containerPadding?: number|string
}) {
  return (
    <>
      <PageContentContainer
        extras={{
          pageMaxWidthContainer: {
            style: {
              maxWidth: '98vw',
            }
          },
          innerContainer: {
            style: {
              padding: '10px',
            }
          },
          ...extras,
        }}
      >
        {heading}
        {topControlsArea}
        <Space h={15} />
        <div
          style={{ backgroundColor: '#ffffff', padding: containerPadding ?? 10, borderRadius: 5 }}
        >
          <Table highlightOnHover>
            <thead style={{ backgroundColor: '#f5f5f5', ...theadStyles }}>
              {tableHeadingRow}
            </thead>
            <tbody>{tableRows}</tbody>
          </Table>
        </div>
      </PageContentContainer>
      <PageContentContainer>{bottomArea}</PageContentContainer>
    </>
  )
}

/*

████████╗ ██████╗ ██████╗      ██████╗ ██████╗ ███╗   ██╗████████╗██████╗  ██████╗ ██╗     ███████╗     █████╗ ██████╗ ███████╗ █████╗ 
╚══██╔══╝██╔═══██╗██╔══██╗    ██╔════╝██╔═══██╗████╗  ██║╚══██╔══╝██╔══██╗██╔═══██╗██║     ██╔════╝    ██╔══██╗██╔══██╗██╔════╝██╔══██╗
   ██║   ██║   ██║██████╔╝    ██║     ██║   ██║██╔██╗ ██║   ██║   ██████╔╝██║   ██║██║     ███████╗    ███████║██████╔╝█████╗  ███████║
   ██║   ██║   ██║██╔═══╝     ██║     ██║   ██║██║╚██╗██║   ██║   ██╔══██╗██║   ██║██║     ╚════██║    ██╔══██║██╔══██╗██╔══╝  ██╔══██║
   ██║   ╚██████╔╝██║         ╚██████╗╚██████╔╝██║ ╚████║   ██║   ██║  ██║╚██████╔╝███████╗███████║    ██║  ██║██║  ██║███████╗██║  ██║
   ╚═╝    ╚═════╝ ╚═╝          ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝   ╚═╝   ╚═╝  ╚═╝ ╚═════╝ ╚══════╝╚══════╝    ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝
                                                                                                                                       
*/

AdminListQuotesPage.TopControlsArea = function ({
  bulkActionsSelect = (
    <Select
      placeholder="Bulk actions"
      value={'bulk-action-1'}
      data={[
        {
          value: 'bulk-action-1',
          label: 'Bulk action #1',
        },
        { value: 'bulk-action-2', label: 'Bulk action #2' },
        { value: 'bulk-action-3', label: 'Bulk action #3' },
      ]}
    />
  ),
  applyButton = <Button styleType="white">Apply</Button>,
  statusSelect = (
    <Select
      placeholder="All Status"
      value={'status-1'}
      data={[
        {
          value: 'all-status-1',
          label: 'All Status #1',
        },
        { value: 'all-status-2', label: 'All Status #2' },
        { value: 'all-status-3', label: 'All Status #3' },
      ]}
    />
  ),
  searchInput = <TextInput placeholder="Search pages" />,
}: {
  bulkActionsSelect?: React.ReactNode
  applyButton?: React.ReactNode
  statusSelect?: React.ReactNode
  searchInput?: React.ReactNode
}) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', width: '100%' }}>
        {bulkActionsSelect}
        <Space w={10} />
        {applyButton}
      </div>
      <div style={{ display: 'flex', marginLeft: 'auto' }}>
        {statusSelect}
        <Space w={10} />
        {searchInput}
      </div>
    </div>
  )
}

/*

████████╗ █████╗ ██████╗ ██╗     ███████╗    ██████╗  ██████╗ ██╗    ██╗
╚══██╔══╝██╔══██╗██╔══██╗██║     ██╔════╝    ██╔══██╗██╔═══██╗██║    ██║
   ██║   ███████║██████╔╝██║     █████╗      ██████╔╝██║   ██║██║ █╗ ██║
   ██║   ██╔══██║██╔══██╗██║     ██╔══╝      ██╔══██╗██║   ██║██║███╗██║
   ██║   ██║  ██║██████╔╝███████╗███████╗    ██║  ██║╚██████╔╝╚███╔███╔╝
   ╚═╝   ╚═╝  ╚═╝╚═════╝ ╚══════╝╚══════╝    ╚═╝  ╚═╝ ╚═════╝  ╚══╝╚══╝ 
                                                                        
*/

AdminListQuotesPage.TableRow = function ({
  backgroundColor = 'grey',
  checkbox = <Checkbox />,
  bookingRef = <Anchor styleType="basic">1234567</Anchor>,
  name = 'Alessandro Buchanan',
  quoteDate = '15 Jan 2022 9.45pm',
  agent = 'Agent',
  urlLink = <Anchor styleType="basic">Link</Anchor>,
  description = 'East Coast Adventure',
  offerExpires = '14 Days',
  status = <Badge variant="dot">pending</Badge>,
  actionButtons = (
    <Menu>
      <Menu.Item>Item 1</Menu.Item>
      <Menu.Item>Item 2</Menu.Item>
      <Menu.Item>Item 3</Menu.Item>
    </Menu>
  ),
  colSpans = [1,1],
  topLine = [
    checkbox,
    bookingRef,
    name,
    quoteDate,
    agent,
    urlLink,
    description,
    offerExpires,
    status,
    actionButtons,
    // for payments:
    // checkbox
    // bookingRef,
    // name,
    // amount,
    // agent,
    // utm,
    // date,
    // status,
    // actionButtons,
  ],
  firstDetailTableRows = [
    AdminListQuotesPage.TableDetailsRow({
      label: 'Phone',
      value: '61 421587126',
    }),
    AdminListQuotesPage.TableDetailsRow({
      label: 'Email',
      value: 'alessandrobuchanan@email.com',
    }),
    AdminListQuotesPage.TableDetailsRow({ label: 'Discount', value: '20%' }),
    AdminListQuotesPage.TableDetailsRow({ label: 'Record No.', value: '2112' }),
    AdminListQuotesPage.TableDetailsRow({ label: 'Agent', value: 'Mikey' }),
  ],
  secondDetailTableRows = [
    AdminListQuotesPage.TableDetailsRow({
      label: 'Pickup location',
      value: 'Byron',
    }),
    AdminListQuotesPage.TableDetailsRow({
      label: 'Drop off location',
      value: 'Sydney',
    }),
    AdminListQuotesPage.TableDetailsRow({
      label: 'Start Date',
      value: '15 Jan 2022',
    }),
    AdminListQuotesPage.TableDetailsRow({
      label: 'End Date',
      value: '30 Jan 2022',
    }),
    AdminListQuotesPage.TableDetailsRow({
      label: 'Duration',
      value: '15 Days',
    }),
  ],
  expanded = false,
  extraControls = (<Select
    placeholder="Complete"
    data={[
      { value: 'Item 1', label: 'Item 1' },
      { value: 'Item 2', label: 'Item 2' },
      { value: 'Item 3', label: 'Item 3' },
    ]}
  ></Select>),
  ...rest // onClick
}: {
  backgroundColor?: string,
  checkbox?: React.ReactNode
  bookingRef?: React.ReactNode
  name?: React.ReactNode
  topLine?: React.ReactNode[]
  colSpans?: number[]
  quoteDate?: React.ReactNode
  agent?: React.ReactNode
  urlLink?: React.ReactNode
  description?: React.ReactNode
  offerExpires?: React.ReactNode
  status?: React.ReactNode
  actionButtons?: React.ReactNode
  firstDetailTableRows?: React.ReactNode
  secondDetailTableRows?: React.ReactNode
  expanded?: boolean
  extraControls?: React.ReactNode
}) {
  return (
    <>
      <tr {...rest}>
        { topLine.map((v:any,i:number)=>{
          return (colSpans[i]==0) ? [] : <td colSpan={colSpans[i]??1}><Text style={{ wordBreak: 'break-all' }}>{v}</Text></td>
        }) }
      </tr>
      <tr style={{backgroundColor}}>
        <td style={{ padding: 0, borderBottom: 0 }}></td>
        <td style={{ padding: 0, borderBottom: 0 }}></td>
        <td colSpan={999} style={{ padding: 0, borderBottom: 0 }}>
          <Collapse in={expanded}>
            <Space h={30} />
            <Grid gutter={30}>
              <Grid.Col span={5}>
                <table>
                  <tbody>{firstDetailTableRows}</tbody>
                </table>
              </Grid.Col>
              <Grid.Col span={5}>
                <table>
                  <tbody>{secondDetailTableRows}</tbody>
                </table>
              </Grid.Col>
              <Grid.Col span={2}>
                {extraControls}
              </Grid.Col>
            </Grid>
            <Space h={30} />
          </Collapse>
        </td>
      </tr>
    </>
  )
}

/*

████████╗ █████╗ ██████╗ ██╗     ███████╗    ██████╗ ███████╗████████╗ █████╗ ██╗██╗     ███████╗    ██████╗  ██████╗ ██╗    ██╗
╚══██╔══╝██╔══██╗██╔══██╗██║     ██╔════╝    ██╔══██╗██╔════╝╚══██╔══╝██╔══██╗██║██║     ██╔════╝    ██╔══██╗██╔═══██╗██║    ██║
   ██║   ███████║██████╔╝██║     █████╗      ██║  ██║█████╗     ██║   ███████║██║██║     ███████╗    ██████╔╝██║   ██║██║ █╗ ██║
   ██║   ██╔══██║██╔══██╗██║     ██╔══╝      ██║  ██║██╔══╝     ██║   ██╔══██║██║██║     ╚════██║    ██╔══██╗██║   ██║██║███╗██║
   ██║   ██║  ██║██████╔╝███████╗███████╗    ██████╔╝███████╗   ██║   ██║  ██║██║███████╗███████║    ██║  ██║╚██████╔╝╚███╔███╔╝
   ╚═╝   ╚═╝  ╚═╝╚═════╝ ╚══════╝╚══════╝    ╚═════╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝╚═╝╚══════╝╚══════╝    ╚═╝  ╚═╝ ╚═════╝  ╚══╝╚══╝ 
                                                                                                                                
*/

AdminListQuotesPage.TableDetailsRow = function ({
  label,
  value,
}: {
  label?: React.ReactNode
  value?: React.ReactNode
}) {
  // We use divs to stop inheriting styles from Mantine's <Table />
  return (
    <tr>
      <div style={{ display: 'table-cell', paddingRight: 20 }}>
        <Text styleType="light">{label}</Text>
      </div>
      <div style={{ display: 'table-cell' }}>
        <Text>{value}</Text>
      </div>
    </tr>
  )
}

/*

██████╗  ██████╗ ████████╗████████╗ ██████╗ ███╗   ███╗     █████╗ ██████╗ ███████╗ █████╗ 
██╔══██╗██╔═══██╗╚══██╔══╝╚══██╔══╝██╔═══██╗████╗ ████║    ██╔══██╗██╔══██╗██╔════╝██╔══██╗
██████╔╝██║   ██║   ██║      ██║   ██║   ██║██╔████╔██║    ███████║██████╔╝█████╗  ███████║
██╔══██╗██║   ██║   ██║      ██║   ██║   ██║██║╚██╔╝██║    ██╔══██║██╔══██╗██╔══╝  ██╔══██║
██████╔╝╚██████╔╝   ██║      ██║   ╚██████╔╝██║ ╚═╝ ██║    ██║  ██║██║  ██║███████╗██║  ██║
╚═════╝  ╚═════╝    ╚═╝      ╚═╝    ╚═════╝ ╚═╝     ╚═╝    ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝
                                                                                                                                                                                             
*/

AdminListQuotesPage.BottomArea = function ({
  leftContent = 'Showing 12 of 5,232 trips',
  rightContent = <Pagination color="brandBlack" page={1} total={3} />,
}: {
  leftContent?: React.ReactNode
  rightContent?: React.ReactNode
}) {
  // We use divs to stop inheriting styles from Mantine's <Table />
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ marginRight: 'auto' }}>{leftContent}</div>
      <div>{rightContent}</div>
    </div>
  )
}
